import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { Observer } from 'mobx-react';
import { toast } from 'react-toastify';

import { ThemeProps } from '@styles/theme';
import { useUserAnalyticUIStore } from '@core/useStores';
import { ToastMessage } from '@shared/components/Toast';
import { messages } from '@shared/shared.messages';
import classNames from 'classnames';
import ExportIcon from '@assets/export.svg';
import { useTheme } from '@mui/material/styles';
import { Button } from '@shared/components/Button';

const useStyles = createUseStyles((theme: ThemeProps) => ({

    buttonExport: {
        width: 'auto',
        height: 'auto',
        marginLeft: 12,
        fontSize: 14,
        fontFamily: theme.font.secondary,
        padding: 8,
    },

    exportIcon: {
        marginRight: 4,
    },
}));

export const UserExecutionsExport: FC = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const userAnalytics = useUserAnalyticUIStore();
    const exportUserExecutions = () => {
        toast.success(
            <ToastMessage
                message={messages['export.toast.inProgress']}
                type='success'
            />
        );
        userAnalytics.exportExecutions(
            {
                id: userAnalytics.requestParams.getParams.userId,
                startDate: userAnalytics.requestParams.getParams.startDate,
                endDate: userAnalytics.requestParams.getParams.endDate,
            });
    }

    return (
        <Observer>
            {() => {
                const {
                    isExporting,
                    canExport,
                } = userAnalytics;

                return (
                    <Button
                        onClick={exportUserExecutions}
                        color='secondary'
                        className={classNames(styles.buttonExport)}
                        disabled={!canExport}
                        loading={isExporting}
                        startIcon={<img src={ExportIcon} className={classNames(styles.exportIcon)} />}>
                        {
                            messages['export.exportButton.executions']
                        }
                    </Button>
                )
            }}
        </Observer>
    )
}
